import { render, staticRenderFns } from "./NewsAttachment.vue?vue&type=template&id=0ca657a6&scoped=true"
import script from "./NewsAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsAttachment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewsAttachment.vue?vue&type=style&index=0&id=0ca657a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca657a6",
  null
  
)

export default component.exports